// extracted by mini-css-extract-plugin
export default {"container":"uL-z","modal":"vL-z","dimensions":"wL-z","brandName":"xL-z","productName":"yL-z","labelValue":"zL-z","recipientEmail":"AL-z","recommendedFit":"BL-z","hiddenField":"CL-z"};